/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum FSWebviewNotRecordedReason {
  DOMAIN_NOT_ALLOWLISTED = 0,
  INJECTION_DISABLED = 1,
  JAVASCRIPT_DISABLED = 2,
  SAFARI_VIEW_CONTROLLER = 3,
  WORKAROUND_WKWEBVIEW_DISABLED = 4,
  WKWEBVIEW_USERSCRIPTS_REMOVED = 5,
  WEBVIEW_EXCLUDED = 6,
}
